
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from "@prisma/client/runtime/index-browser"

export type * from '../models.ts'
export type * from './prismaNamespace.ts'

export const Decimal = runtime.Decimal


export const NullTypes = {
  DbNull: runtime.NullTypes.DbNull as (new (secret: never) => typeof runtime.DbNull),
  JsonNull: runtime.NullTypes.JsonNull as (new (secret: never) => typeof runtime.JsonNull),
  AnyNull: runtime.NullTypes.AnyNull as (new (secret: never) => typeof runtime.AnyNull),
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull

/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull

/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull


export const ModelName = {
  Academy: 'Academy',
  AcademyImage: 'AcademyImage',
  AcademyUnit: 'AcademyUnit',
  AcademyUnitCourt: 'AcademyUnitCourt',
  Achievement: 'Achievement',
  Badge: 'Badge',
  Notification: 'Notification',
  UserInvitation: 'UserInvitation',
  User: 'User',
  UserMobileAppVersionFirstSeen: 'UserMobileAppVersionFirstSeen',
  UserAvailability: 'UserAvailability',
  Follow: 'Follow',
  Password: 'Password',
  Session: 'Session',
  StaffAccount: 'StaffAccount',
  StaffSession: 'StaffSession',
  Permission: 'Permission',
  Role: 'Role',
  Verification: 'Verification',
  PlayerProfile: 'PlayerProfile',
  Racket: 'Racket',
  PlayerProfileRacket: 'PlayerProfileRacket',
  Connection: 'Connection',
  Match: 'Match',
  MatchChallenge: 'MatchChallenge',
  MatchRanking: 'MatchRanking',
  MatchRankingScore: 'MatchRankingScore',
  MatchResultEditAudit: 'MatchResultEditAudit',
  Chat: 'Chat',
  Ranking: 'Ranking',
  RankingPosition: 'RankingPosition',
  RankingScore: 'RankingScore',
  RankingJoinRequest: 'RankingJoinRequest',
  RankingAdmin: 'RankingAdmin',
  UserFeature: 'UserFeature',
  MatchRating: 'MatchRating',
  TeacherProfile: 'TeacherProfile',
  TeachingAddress: 'TeachingAddress',
  TeacherRating: 'TeacherRating',
  Address: 'Address',
  UserAddress: 'UserAddress',
  ContactMessage: 'ContactMessage',
  Testimonial: 'Testimonial',
  Brand: 'Brand',
  Conversation: 'Conversation',
  ConversationParticipant: 'ConversationParticipant',
  Message: 'Message',
  OutboundCampaign: 'OutboundCampaign',
  OutboundCampaignDelivery: 'OutboundCampaignDelivery',
  DmDailyEmailSent: 'DmDailyEmailSent',
  MessageEncryptedKey: 'MessageEncryptedKey',
  UserDevice: 'UserDevice',
  SurfaceAccessEvent: 'SurfaceAccessEvent',
  DynamicContent: 'DynamicContent',
  DynamicChallengeCard: 'DynamicChallengeCard',
  AccountDeletionRequest: 'AccountDeletionRequest',
  PushGameSuggestion: 'PushGameSuggestion'
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]

/*
 * Enums
 */

export const TransactionIsolationLevel = runtime.makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
} as const)

export type TransactionIsolationLevel = (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]


export const AcademyScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  name: 'name',
  description: 'description',
  profilePictureUrl: 'profilePictureUrl',
  sports: 'sports',
  email: 'email',
  instagram: 'instagram',
  facebook: 'facebook',
  tiktok: 'tiktok',
  x: 'x',
  youtube: 'youtube',
  website: 'website',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AcademyScalarFieldEnum = (typeof AcademyScalarFieldEnum)[keyof typeof AcademyScalarFieldEnum]


export const AcademyImageScalarFieldEnum = {
  id: 'id',
  academyId: 'academyId',
  pictureUrl: 'pictureUrl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AcademyImageScalarFieldEnum = (typeof AcademyImageScalarFieldEnum)[keyof typeof AcademyImageScalarFieldEnum]


export const AcademyUnitScalarFieldEnum = {
  id: 'id',
  name: 'name',
  phone: 'phone',
  email: 'email',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  academyId: 'academyId',
  addressId: 'addressId',
  amenities: 'amenities'
} as const

export type AcademyUnitScalarFieldEnum = (typeof AcademyUnitScalarFieldEnum)[keyof typeof AcademyUnitScalarFieldEnum]


export const AcademyUnitCourtScalarFieldEnum = {
  id: 'id',
  quantity: 'quantity',
  type: 'type',
  sport: 'sport',
  covered: 'covered',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  unitId: 'unitId'
} as const

export type AcademyUnitCourtScalarFieldEnum = (typeof AcademyUnitCourtScalarFieldEnum)[keyof typeof AcademyUnitCourtScalarFieldEnum]


export const AchievementScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  badgeId: 'badgeId',
  progress: 'progress',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AchievementScalarFieldEnum = (typeof AchievementScalarFieldEnum)[keyof typeof AchievementScalarFieldEnum]


export const BadgeScalarFieldEnum = {
  id: 'id',
  sport: 'sport',
  name: 'name',
  description: 'description',
  requirement: 'requirement',
  requiredProgress: 'requiredProgress',
  group: 'group',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  unlockedByBadgeId: 'unlockedByBadgeId'
} as const

export type BadgeScalarFieldEnum = (typeof BadgeScalarFieldEnum)[keyof typeof BadgeScalarFieldEnum]


export const NotificationScalarFieldEnum = {
  id: 'id',
  key: 'key',
  template: 'template',
  userId: 'userId',
  properties: 'properties',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiresAt: 'expiresAt',
  readAt: 'readAt'
} as const

export type NotificationScalarFieldEnum = (typeof NotificationScalarFieldEnum)[keyof typeof NotificationScalarFieldEnum]


export const UserInvitationScalarFieldEnum = {
  id: 'id',
  email: 'email',
  invitedBy: 'invitedBy',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserInvitationScalarFieldEnum = (typeof UserInvitationScalarFieldEnum)[keyof typeof UserInvitationScalarFieldEnum]


export const UserScalarFieldEnum = {
  id: 'id',
  email: 'email',
  username: 'username',
  firstName: 'firstName',
  lastName: 'lastName',
  fullNameSearch: 'fullNameSearch',
  gender: 'gender',
  birthday: 'birthday',
  nationality: 'nationality',
  profilePictureUrl: 'profilePictureUrl',
  zipcode: 'zipcode',
  addressStreet: 'addressStreet',
  addressNeighborhood: 'addressNeighborhood',
  addressCity: 'addressCity',
  addressState: 'addressState',
  latitude: 'latitude',
  longitude: 'longitude',
  level: 'level',
  pushToken: 'pushToken',
  referredById: 'referredById',
  lastMobileAppAccessAt: 'lastMobileAppAccessAt',
  lastMobileAppVersion: 'lastMobileAppVersion',
  lastMobileAppPlatform: 'lastMobileAppPlatform',
  profileSearchVisibility: 'profileSearchVisibility',
  conversationVisibility: 'conversationVisibility',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type UserScalarFieldEnum = (typeof UserScalarFieldEnum)[keyof typeof UserScalarFieldEnum]


export const UserMobileAppVersionFirstSeenScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  appVersion: 'appVersion',
  platform: 'platform',
  firstSeenAt: 'firstSeenAt'
} as const

export type UserMobileAppVersionFirstSeenScalarFieldEnum = (typeof UserMobileAppVersionFirstSeenScalarFieldEnum)[keyof typeof UserMobileAppVersionFirstSeenScalarFieldEnum]


export const UserAvailabilityScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  date: 'date',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  recurring: 'recurring',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserAvailabilityScalarFieldEnum = (typeof UserAvailabilityScalarFieldEnum)[keyof typeof UserAvailabilityScalarFieldEnum]


export const FollowScalarFieldEnum = {
  followedUserId: 'followedUserId',
  followerUserId: 'followerUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type FollowScalarFieldEnum = (typeof FollowScalarFieldEnum)[keyof typeof FollowScalarFieldEnum]


export const PasswordScalarFieldEnum = {
  hash: 'hash',
  userId: 'userId'
} as const

export type PasswordScalarFieldEnum = (typeof PasswordScalarFieldEnum)[keyof typeof PasswordScalarFieldEnum]


export const SessionScalarFieldEnum = {
  id: 'id',
  expirationDate: 'expirationDate',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  deviceId: 'deviceId',
  lastUsedAt: 'lastUsedAt',
  mobile: 'mobile',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId'
} as const

export type SessionScalarFieldEnum = (typeof SessionScalarFieldEnum)[keyof typeof SessionScalarFieldEnum]


export const StaffAccountScalarFieldEnum = {
  id: 'id',
  email: 'email',
  passwordHash: 'passwordHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  disabledAt: 'disabledAt'
} as const

export type StaffAccountScalarFieldEnum = (typeof StaffAccountScalarFieldEnum)[keyof typeof StaffAccountScalarFieldEnum]


export const StaffSessionScalarFieldEnum = {
  id: 'id',
  expirationDate: 'expirationDate',
  staffAccountId: 'staffAccountId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type StaffSessionScalarFieldEnum = (typeof StaffSessionScalarFieldEnum)[keyof typeof StaffSessionScalarFieldEnum]


export const PermissionScalarFieldEnum = {
  id: 'id',
  action: 'action',
  entity: 'entity',
  access: 'access',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PermissionScalarFieldEnum = (typeof PermissionScalarFieldEnum)[keyof typeof PermissionScalarFieldEnum]


export const RoleScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type RoleScalarFieldEnum = (typeof RoleScalarFieldEnum)[keyof typeof RoleScalarFieldEnum]


export const VerificationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  type: 'type',
  target: 'target',
  secret: 'secret',
  algorithm: 'algorithm',
  digits: 'digits',
  period: 'period',
  charSet: 'charSet',
  expiresAt: 'expiresAt'
} as const

export type VerificationScalarFieldEnum = (typeof VerificationScalarFieldEnum)[keyof typeof VerificationScalarFieldEnum]


export const PlayerProfileScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  sport: 'sport',
  level: 'level',
  levelCertificationStartedAt: 'levelCertificationStartedAt',
  direction: 'direction',
  backhand: 'backhand',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PlayerProfileScalarFieldEnum = (typeof PlayerProfileScalarFieldEnum)[keyof typeof PlayerProfileScalarFieldEnum]


export const RacketScalarFieldEnum = {
  id: 'id',
  brand: 'brand',
  model: 'model',
  sport: 'sport',
  verified: 'verified',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type RacketScalarFieldEnum = (typeof RacketScalarFieldEnum)[keyof typeof RacketScalarFieldEnum]


export const PlayerProfileRacketScalarFieldEnum = {
  id: 'id',
  profileId: 'profileId',
  racketId: 'racketId',
  isActive: 'isActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PlayerProfileRacketScalarFieldEnum = (typeof PlayerProfileRacketScalarFieldEnum)[keyof typeof PlayerProfileRacketScalarFieldEnum]


export const ConnectionScalarFieldEnum = {
  id: 'id',
  providerName: 'providerName',
  providerId: 'providerId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId'
} as const

export type ConnectionScalarFieldEnum = (typeof ConnectionScalarFieldEnum)[keyof typeof ConnectionScalarFieldEnum]


export const MatchScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  type: 'type',
  acceptedGenders: 'acceptedGenders',
  acceptedLevels: 'acceptedLevels',
  date: 'date',
  hour: 'hour',
  period: 'period',
  duration: 'duration',
  reservedCourt: 'reservedCourt',
  coveredCourt: 'coveredCourt',
  address: 'address',
  addressId: 'addressId',
  acceptedCourtTypes: 'acceptedCourtTypes',
  selectedCourtType: 'selectedCourtType',
  selectedCoveredCourt: 'selectedCoveredCourt',
  costsInvolved: 'costsInvolved',
  cost: 'cost',
  costDescription: 'costDescription',
  notes: 'notes',
  description: 'description',
  privacy: 'privacy',
  finalScore: 'finalScore',
  scoreDetails: 'scoreDetails',
  rankingType: 'rankingType',
  cancellationReason: 'cancellationReason',
  finishedAt: 'finishedAt',
  deletedByUserId: 'deletedByUserId'
} as const

export type MatchScalarFieldEnum = (typeof MatchScalarFieldEnum)[keyof typeof MatchScalarFieldEnum]


export const MatchChallengeScalarFieldEnum = {
  id: 'id',
  matchId: 'matchId',
  userId: 'userId',
  status: 'status',
  owner: 'owner',
  winner: 'winner',
  scoreIfWins: 'scoreIfWins',
  scoreIfLoses: 'scoreIfLoses',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MatchChallengeScalarFieldEnum = (typeof MatchChallengeScalarFieldEnum)[keyof typeof MatchChallengeScalarFieldEnum]


export const MatchRankingScalarFieldEnum = {
  id: 'id',
  matchId: 'matchId',
  rankingId: 'rankingId',
  deletedByUserId: 'deletedByUserId',
  deletedBy: 'deletedBy',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MatchRankingScalarFieldEnum = (typeof MatchRankingScalarFieldEnum)[keyof typeof MatchRankingScalarFieldEnum]


export const MatchRankingScoreScalarFieldEnum = {
  id: 'id',
  matchId: 'matchId',
  rankingId: 'rankingId',
  userId: 'userId',
  pointsDelta: 'pointsDelta',
  participationDelta: 'participationDelta',
  matchesWonDelta: 'matchesWonDelta',
  matchesLostDelta: 'matchesLostDelta',
  setsWonDelta: 'setsWonDelta',
  setsLostDelta: 'setsLostDelta',
  gamesWonDelta: 'gamesWonDelta',
  gamesLostDelta: 'gamesLostDelta',
  appliedScoringMode: 'appliedScoringMode',
  ruleVersion: 'ruleVersion',
  rulePointsWin: 'rulePointsWin',
  rulePointsLoss: 'rulePointsLoss',
  appliedAt: 'appliedAt',
  revertedAt: 'revertedAt',
  revertedReason: 'revertedReason'
} as const

export type MatchRankingScoreScalarFieldEnum = (typeof MatchRankingScoreScalarFieldEnum)[keyof typeof MatchRankingScoreScalarFieldEnum]


export const MatchResultEditAuditScalarFieldEnum = {
  id: 'id',
  matchId: 'matchId',
  editedByUserId: 'editedByUserId',
  previousFinalScore: 'previousFinalScore',
  previousScoreDetails: 'previousScoreDetails',
  newFinalScore: 'newFinalScore',
  newScoreDetails: 'newScoreDetails',
  createdAt: 'createdAt'
} as const

export type MatchResultEditAuditScalarFieldEnum = (typeof MatchResultEditAuditScalarFieldEnum)[keyof typeof MatchResultEditAuditScalarFieldEnum]


export const ChatScalarFieldEnum = {
  id: 'id',
  source: 'source',
  userId: 'userId',
  message: 'message',
  readAt: 'readAt',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ChatScalarFieldEnum = (typeof ChatScalarFieldEnum)[keyof typeof ChatScalarFieldEnum]


export const RankingScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  periodStart: 'periodStart',
  periodEnd: 'periodEnd',
  acceptedGender: 'acceptedGender',
  imageUrl: 'imageUrl',
  emoji: 'emoji',
  description: 'description',
  levels: 'levels',
  type: 'type',
  createdById: 'createdById',
  isPublic: 'isPublic',
  scoringMode: 'scoringMode',
  pointsWin: 'pointsWin',
  pointsLoss: 'pointsLoss',
  matchLimitEnabled: 'matchLimitEnabled',
  matchLimitCount: 'matchLimitCount',
  matchLimitPeriod: 'matchLimitPeriod',
  tiebreakCriteria: 'tiebreakCriteria',
  tiebreakCriteriaOrder: 'tiebreakCriteriaOrder',
  matchFormat: 'matchFormat',
  addressId: 'addressId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  deletionCleanupAt: 'deletionCleanupAt'
} as const

export type RankingScalarFieldEnum = (typeof RankingScalarFieldEnum)[keyof typeof RankingScalarFieldEnum]


export const RankingPositionScalarFieldEnum = {
  rankingId: 'rankingId',
  userId: 'userId',
  date: 'date',
  current: 'current',
  score: 'score',
  position: 'position',
  internalPosition: 'internalPosition'
} as const

export type RankingPositionScalarFieldEnum = (typeof RankingPositionScalarFieldEnum)[keyof typeof RankingPositionScalarFieldEnum]


export const RankingScoreScalarFieldEnum = {
  rankingId: 'rankingId',
  userId: 'userId',
  score: 'score',
  participations: 'participations',
  createdAt: 'createdAt',
  matchesWon: 'matchesWon',
  matchesLost: 'matchesLost',
  setsWon: 'setsWon',
  setsLost: 'setsLost',
  gamesWon: 'gamesWon',
  gamesLost: 'gamesLost',
  deletedAt: 'deletedAt',
  participantRemovedById: 'participantRemovedById',
  participantRemovedAt: 'participantRemovedAt'
} as const

export type RankingScoreScalarFieldEnum = (typeof RankingScoreScalarFieldEnum)[keyof typeof RankingScoreScalarFieldEnum]


export const RankingJoinRequestScalarFieldEnum = {
  id: 'id',
  rankingId: 'rankingId',
  userId: 'userId',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  respondedAt: 'respondedAt',
  respondedById: 'respondedById'
} as const

export type RankingJoinRequestScalarFieldEnum = (typeof RankingJoinRequestScalarFieldEnum)[keyof typeof RankingJoinRequestScalarFieldEnum]


export const RankingAdminScalarFieldEnum = {
  id: 'id',
  rankingId: 'rankingId',
  userId: 'userId',
  createdAt: 'createdAt',
  addedById: 'addedById',
  deletedAt: 'deletedAt'
} as const

export type RankingAdminScalarFieldEnum = (typeof RankingAdminScalarFieldEnum)[keyof typeof RankingAdminScalarFieldEnum]


export const UserFeatureScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  feature: 'feature',
  enabled: 'enabled',
  createdAt: 'createdAt'
} as const

export type UserFeatureScalarFieldEnum = (typeof UserFeatureScalarFieldEnum)[keyof typeof UserFeatureScalarFieldEnum]


export const MatchRatingScalarFieldEnum = {
  evaluatedPlayerProfileId: 'evaluatedPlayerProfileId',
  reviewerId: 'reviewerId',
  matchId: 'matchId',
  playerLevel: 'playerLevel',
  playerBehavior: 'playerBehavior',
  courtRating: 'courtRating',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MatchRatingScalarFieldEnum = (typeof MatchRatingScalarFieldEnum)[keyof typeof MatchRatingScalarFieldEnum]


export const TeacherProfileScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  bio: 'bio',
  certificates: 'certificates',
  professionalPhoneNumber: 'professionalPhoneNumber',
  professionalEmail: 'professionalEmail',
  instagram: 'instagram',
  facebook: 'facebook',
  tiktok: 'tiktok',
  teachingServices: 'teachingServices',
  teachingLevels: 'teachingLevels',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TeacherProfileScalarFieldEnum = (typeof TeacherProfileScalarFieldEnum)[keyof typeof TeacherProfileScalarFieldEnum]


export const TeachingAddressScalarFieldEnum = {
  id: 'id',
  teacherProfileId: 'teacherProfileId',
  addressId: 'addressId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TeachingAddressScalarFieldEnum = (typeof TeachingAddressScalarFieldEnum)[keyof typeof TeachingAddressScalarFieldEnum]


export const TeacherRatingScalarFieldEnum = {
  id: 'id',
  teacherProfileId: 'teacherProfileId',
  userId: 'userId',
  rating: 'rating',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TeacherRatingScalarFieldEnum = (typeof TeacherRatingScalarFieldEnum)[keyof typeof TeacherRatingScalarFieldEnum]


export const AddressScalarFieldEnum = {
  id: 'id',
  placeId: 'placeId',
  name: 'name',
  formattedAddress: 'formattedAddress',
  street: 'street',
  state: 'state',
  streetNumber: 'streetNumber',
  neighborhood: 'neighborhood',
  city: 'city',
  country: 'country',
  zipCode: 'zipCode',
  lat: 'lat',
  long: 'long',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AddressScalarFieldEnum = (typeof AddressScalarFieldEnum)[keyof typeof AddressScalarFieldEnum]


export const UserAddressScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  addressId: 'addressId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserAddressScalarFieldEnum = (typeof UserAddressScalarFieldEnum)[keyof typeof UserAddressScalarFieldEnum]


export const ContactMessageScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  phone: 'phone',
  message: 'message',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ContactMessageScalarFieldEnum = (typeof ContactMessageScalarFieldEnum)[keyof typeof ContactMessageScalarFieldEnum]


export const TestimonialScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  teacherProfileId: 'teacherProfileId',
  message: 'message',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TestimonialScalarFieldEnum = (typeof TestimonialScalarFieldEnum)[keyof typeof TestimonialScalarFieldEnum]


export const BrandScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  logoUrl: 'logoUrl',
  isVerified: 'isVerified',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type BrandScalarFieldEnum = (typeof BrandScalarFieldEnum)[keyof typeof BrandScalarFieldEnum]


export const ConversationScalarFieldEnum = {
  id: 'id',
  brandId: 'brandId',
  lastMessageId: 'lastMessageId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ConversationScalarFieldEnum = (typeof ConversationScalarFieldEnum)[keyof typeof ConversationScalarFieldEnum]


export const ConversationParticipantScalarFieldEnum = {
  id: 'id',
  conversationId: 'conversationId',
  userId: 'userId',
  lastReadMessageId: 'lastReadMessageId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ConversationParticipantScalarFieldEnum = (typeof ConversationParticipantScalarFieldEnum)[keyof typeof ConversationParticipantScalarFieldEnum]


export const MessageScalarFieldEnum = {
  id: 'id',
  conversationId: 'conversationId',
  senderId: 'senderId',
  brandId: 'brandId',
  encryptedContent: 'encryptedContent',
  encryptedMetadata: 'encryptedMetadata',
  payloadJson: 'payloadJson',
  editedAt: 'editedAt',
  deletedAt: 'deletedAt',
  readAt: 'readAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MessageScalarFieldEnum = (typeof MessageScalarFieldEnum)[keyof typeof MessageScalarFieldEnum]


export const OutboundCampaignScalarFieldEnum = {
  id: 'id',
  brandId: 'brandId',
  body: 'body',
  imageUrl: 'imageUrl',
  actionsJson: 'actionsJson',
  audienceJson: 'audienceJson',
  status: 'status',
  createdByStaffEmail: 'createdByStaffEmail',
  totalRecipients: 'totalRecipients',
  sentCount: 'sentCount',
  failedCount: 'failedCount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OutboundCampaignScalarFieldEnum = (typeof OutboundCampaignScalarFieldEnum)[keyof typeof OutboundCampaignScalarFieldEnum]


export const OutboundCampaignDeliveryScalarFieldEnum = {
  id: 'id',
  campaignId: 'campaignId',
  userId: 'userId',
  conversationId: 'conversationId',
  messageId: 'messageId',
  status: 'status',
  error: 'error',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OutboundCampaignDeliveryScalarFieldEnum = (typeof OutboundCampaignDeliveryScalarFieldEnum)[keyof typeof OutboundCampaignDeliveryScalarFieldEnum]


export const DmDailyEmailSentScalarFieldEnum = {
  id: 'id',
  senderId: 'senderId',
  recipientId: 'recipientId',
  day: 'day',
  messageId: 'messageId',
  createdAt: 'createdAt'
} as const

export type DmDailyEmailSentScalarFieldEnum = (typeof DmDailyEmailSentScalarFieldEnum)[keyof typeof DmDailyEmailSentScalarFieldEnum]


export const MessageEncryptedKeyScalarFieldEnum = {
  id: 'id',
  messageId: 'messageId',
  deviceId: 'deviceId',
  encryptedKey: 'encryptedKey',
  createdAt: 'createdAt'
} as const

export type MessageEncryptedKeyScalarFieldEnum = (typeof MessageEncryptedKeyScalarFieldEnum)[keyof typeof MessageEncryptedKeyScalarFieldEnum]


export const UserDeviceScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  deviceId: 'deviceId',
  deviceName: 'deviceName',
  publicKey: 'publicKey',
  isActive: 'isActive',
  lastSeenAt: 'lastSeenAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserDeviceScalarFieldEnum = (typeof UserDeviceScalarFieldEnum)[keyof typeof UserDeviceScalarFieldEnum]


export const SurfaceAccessEventScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  kind: 'kind',
  contentSlug: 'contentSlug',
  platform: 'platform',
  appVersion: 'appVersion',
  createdAt: 'createdAt'
} as const

export type SurfaceAccessEventScalarFieldEnum = (typeof SurfaceAccessEventScalarFieldEnum)[keyof typeof SurfaceAccessEventScalarFieldEnum]


export const DynamicContentScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  title: 'title',
  content: 'content',
  publishAt: 'publishAt',
  expiresAt: 'expiresAt',
  bannerImageUrl: 'bannerImageUrl',
  summary: 'summary',
  showInSpotlights: 'showInSpotlights',
  sortOrder: 'sortOrder',
  isDraft: 'isDraft',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type DynamicContentScalarFieldEnum = (typeof DynamicContentScalarFieldEnum)[keyof typeof DynamicContentScalarFieldEnum]


export const DynamicChallengeCardScalarFieldEnum = {
  id: 'id',
  description: 'description',
  icon: 'icon',
  backgroundClassName: 'backgroundClassName',
  backgroundImageUrl: 'backgroundImageUrl',
  isDraft: 'isDraft',
  fullWidth: 'fullWidth',
  redirectTo: 'redirectTo',
  startsAt: 'startsAt',
  endsAt: 'endsAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type DynamicChallengeCardScalarFieldEnum = (typeof DynamicChallengeCardScalarFieldEnum)[keyof typeof DynamicChallengeCardScalarFieldEnum]


export const AccountDeletionRequestScalarFieldEnum = {
  id: 'id',
  token: 'token',
  userId: 'userId',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AccountDeletionRequestScalarFieldEnum = (typeof AccountDeletionRequestScalarFieldEnum)[keyof typeof AccountDeletionRequestScalarFieldEnum]


export const PushGameSuggestionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  suggestedUserId: 'suggestedUserId',
  sentAt: 'sentAt'
} as const

export type PushGameSuggestionScalarFieldEnum = (typeof PushGameSuggestionScalarFieldEnum)[keyof typeof PushGameSuggestionScalarFieldEnum]


export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]


export const JsonNullValueInput = {
  JsonNull: JsonNull
} as const

export type JsonNullValueInput = (typeof JsonNullValueInput)[keyof typeof JsonNullValueInput]


export const NullableJsonNullValueInput = {
  DbNull: DbNull,
  JsonNull: JsonNull
} as const

export type NullableJsonNullValueInput = (typeof NullableJsonNullValueInput)[keyof typeof NullableJsonNullValueInput]


export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]


export const NullsOrder = {
  first: 'first',
  last: 'last'
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]


export const JsonNullValueFilter = {
  DbNull: DbNull,
  JsonNull: JsonNull,
  AnyNull: AnyNull
} as const

export type JsonNullValueFilter = (typeof JsonNullValueFilter)[keyof typeof JsonNullValueFilter]

